module.exports = __webpack_public_path__ + "media/images/cleaning/koceila-0ebfaecfedf61e41a6a81aeaa5bfa93a.jpg";